import { render, staticRenderFns } from "./PersonProfileMasterNotes.vue?vue&type=template&id=2731a16e&"
import script from "./PersonProfileMasterNotes.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports